<template>
<div class="main-container">
  <a-table 
  :locale="{
    emptyText: '暂无数据'
  }"
    rowKey="primaryCategoryId" 
    :columns="columns" 
    :data-source="data" 
    @change="handleTableChange" 
    :pagination="pagination"  
    style="margin-top: 12px;" >
    <span slot="categoryName" slot-scope="text,record" >{{text}}</span>
    <span slot="level">一级</span>
    <a slot="action" slot-scope="text" @click="openModal(2,text.primaryCategoryId)">授权渠道商</a>
  </a-table>
    <transferCategory ref="transferCategory" />
</div>
  
</template>
<script>
import page from "@/assets/mixin/page.js";
import transferCategory from "./components/transferCategory"
const columns = [
  {
    title: '分类名称',
    dataIndex: 'primaryCategoryName',
    key: 'primaryCategoryName',
  },
  {
    title: '级别',
    key: 'level',
    scopedSlots: { customRender: 'level' },
  },
  {
    title: '可授权商品数',
    key: 'mdseCnt',
    dataIndex:'mdseCnt',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  mixins: [page],
  components:{transferCategory},
  data() {
    return {
      data:[],
      columns,
    };
  },
  created(){
    this.getdata()
  },
  methods:{
    getdata(){
      this.$http.post('merchandise/queryPriCateMdseList',{pageNum:this.pagination.current}).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;
      })
    },
    openModal(index,primaryCategoryId){
       if(index=='2') {
        this.$refs.transferCategory.showModal(primaryCategoryId)
      }
    }
  }
};
</script>
<style lang="less" scoped>
.search-box{
  padding: 29px 24px;
  height: 80px;
  margin-bottom: 24px;
  background-color: rgb(247, 248, 249);
  .ant-btn{
    margin-right: 8px;
  }
  .ant-input{
    width: 216px;
    margin-right: 80px;
  }
}
.table-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .addbtn{
    
  }
}

</style>
